import type { ApiSchemas } from '$lib/api/shopwareApi.js';
import type { ComponentType, SvelteComponent } from 'svelte';
import WineProductListing from '$lib/components/product/productComponents/WineProductListing.svelte';
import PackageProductListing from '$lib/components/product/productComponents/PackageProductListing.svelte';
import TicketProductListing from '$lib/components/product/productComponents/TicketProductListing.svelte';

type ProductComponent = ComponentType<SvelteComponent<{ product: ApiSchemas['Product']; cart: ApiSchemas['Cart'] }>>;

export const productComponents: {
    [key: string]: ProductComponent;
} = {
    Wein: WineProductListing,
    Paket: PackageProductListing,
    Ticket: TicketProductListing
};
